import { render, staticRenderFns } from "./CreateNewAdmin.vue?vue&type=template&id=2b42c146&scoped=true"
import script from "./CreateNewAdmin.vue?vue&type=script&lang=js"
export * from "./CreateNewAdmin.vue?vue&type=script&lang=js"
import style0 from "./CreateNewAdmin.vue?vue&type=style&index=0&id=2b42c146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b42c146",
  null
  
)

export default component.exports